import { Users, MonitorPlay, FileText, ClipboardCheck, BadgeCheck, BookOpen } from 'lucide-react';

const tabs = [
  {
    label: 'Committees',
    icon: Users,
  },
  {
    label: 'Meetings',
    icon: MonitorPlay,
  },
  {
    label: 'Decisions',
    icon: FileText,
  },
  {
    label: 'Actions',
    icon: ClipboardCheck,
  },
  {
    label: 'External Approvals',
    icon: BadgeCheck,
  },
  {
    label: 'Reports',
    icon: BookOpen,
  },
];

const CommitteeTabs = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 px-4">
      <div className="flex items-center justify-between">
        {tabs.map((tab, index) => {
          const Icon = tab.icon;

          return (
            <button
              key={tab.label}
              className={`
                relative
                flex
                items-center
                gap-2
                py-5
                px-4
                text-sm
                font-medium
                transition-colors
                ${index === 0 ? 'text-[#2DD4BF]' : 'text-slate-500 hover:text-slate-700'}
              `}
            >
              <Icon size={16} />

              <span>{tab.label}</span>

              {index === 0 && (
                <div
                  className="
                    absolute
                    bottom-0
                    left-0
                    w-full
                    h-[3px]
                    bg-[#2DD4BF]
                    rounded-full
                  "
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CommitteeTabs;
